import { z } from "zod";

export const validateNameSchema = z
  .string()
  .trim()
  .min(2, "Name must be at least 2 characters")
  .max(50, "Name must not exceed 50 characters")
  .refine((value) => !/\s{2,}/.test(value), {
    message: "Name must not contain consecutive spaces",
  })
  .refine((value) => !/[0-9]/.test(value), {
    message: "Name cannot contain numbers",
  })
  .refine((value) => !/[<>/\\;:[\]{}!@#$%^*+=_]/.test(value), {
    message: "Name contains prohibited characters",
  })
  .refine((value) => /^[A-Za-z]+(?:[ .'-][A-Za-z]*)*\.?$/.test(value), {
    message: "Name contains invalid characters",
  });

export const nameOnlySchema = z.object({
  firstName: validateNameSchema,
  lastName: validateNameSchema,
});

export type NameData = z.infer<typeof nameOnlySchema>;
